// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"textEditorToolbarStyles_toolbar__1uUZm"};